import {gsap} from "gsap";
import {XW2GameMode, XwaysHoarder2} from "../../XwaysHoarder2";


export class TransitionPlayer {

    constructor() {}

    public playGameIntro(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            XwaysHoarder2.backgroundElements.playGameIntroSpine(),
            XwaysHoarder2.foregroundElements.playGameIntroSpine()
        ]);

        return tl;
    }

    public playSpineTransition(toMode:XW2GameMode, fromMode:XW2GameMode): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        //this.stopSpineIdleLoop();
        tl.add([
            //this.stopSpineIdleLoop(),
            XwaysHoarder2.backgroundElements.makeTransition(toMode, fromMode),
            XwaysHoarder2.foregroundElements.makeTransition(toMode, fromMode)
        ]);

        return tl;
    }

    public stopSpineIdleLoop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            XwaysHoarder2.backgroundElements.stopLoop(),
            XwaysHoarder2.foregroundElements.stopLoop(),
        ]);

        return tl;
    }

    playSpineIdleLoop(gameMode:XW2GameMode): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            XwaysHoarder2.backgroundElements.playIdleLoop(gameMode),
            XwaysHoarder2.foregroundElements.playIdleLoop(gameMode)
        ]);

        return tl;
    }

    public playMgToSfs(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        return tl;
    }


    private tranistionSpineMgToFs(currentBG: PIXI.Sprite, nextBG: PIXI.Sprite): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        return tl;
    }

    private tranistionSpineMgToSfs(currentBG: PIXI.Sprite, nextBG: PIXI.Sprite): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        return tl;
    }

    private tranistionSpineFsToSfs(currentBG: PIXI.Sprite, nextBG: PIXI.Sprite): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        return tl;
    }
}